import React, { useEffect, useState } from "react";
import DockerfileInfo from "./dockerfileInfo";
import Trash from "./trash";

const DockerfileBlock = ({ dockerfile, updateDeleteDocker, updateDockerArray, updateDockerfiles, dockerfiles, isDarkTheme }) => {
    const [isOpen, setIsOpen] = useState();
    const [requestLifeCycle, setRequestLifeCycle] = useState(false);

    const fetchDockerfile = async () => {
        try {
            setRequestLifeCycle(true)
            const res = await fetch( process.env.REACT_APP_EVALUATION_API_URL + `/get-dockerfile/${dockerfile.dockerUuid}`, {
                method: "GET",
                credentials: "include"
            });
            const data = await res.json();
            if (res.status === 200) {                           
                updateDockerfiles(dockerfile.dockerUuid, data.dockerfile);
            } else if (res.status === 401) {
                window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
            }
        } catch (error) {
            console.log(error);
        } finally {
            setRequestLifeCycle(false);
        }
    }

    useEffect(() => {
        // we don't have one
        if (!dockerfiles[dockerfile.dockerUuid] && isOpen) {
            fetchDockerfile();
        }

    }, [dockerfiles[dockerfile.dockerUuid], isOpen])

    return (
        <>
            <div style={{ width: "100%" }}>
                <div className="dockerfile-object-row" style={{ borderRadius: isOpen ? "5px 5px 0px 0px" : "" }}>
                    <div className="docker-chevron-container" onClick={() => {setIsOpen((prev) => !prev)}} style={{ cursor: "pointer" }}>
                        <div style={{ minWidth: "16px" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="var(--accent-one)" color="var(--accent-one)" width="20" height="20" viewBox="0 0 640 512">
                                <path color="var(--accent-one)" d="M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4 .4 67.6 .1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"/>
                            </svg>
                        </div>
                        <div className="docker-name">
                            {dockerfile?.name}
                        </div>
                        <div>
                            <div className="center-chevron">
                                {
                                    isOpen ?

                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                                    </svg>

                                    :

                                    
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                        <path d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                                    </svg>

                                }
                            </div>
                        </div>
                    </div>                    
                    {/* handle dockerfile deletion */}
                    <Trash updateDeleteForm={() => {
                        updateDeleteDocker(true, dockerfile);
                    }}/>
                </div>
                {
                    isOpen
    
                    ?
    
                    <div className="bottom-output">
                        <DockerfileInfo updateDockerfiles={updateDockerfiles} isDarkTheme={isDarkTheme} dockerfileText={dockerfiles[dockerfile.dockerUuid]} requestLifeCycle={requestLifeCycle} updateDockerArray={updateDockerArray} dockerfile={dockerfile}/>                        
                    </div>
    
                    :
    
                    <>
                    </>
    
                }
            </div>            
        </>
    );
}

export default DockerfileBlock;